@use "@/styles/board";
@use "@/styles/variables";
@use "@/styles/z-index";

/* stylelint-disable */
:export {
  stickySize: variables.$sticky-size;
  fakeZoom: variables.$fake-zoom;
  editZoom: variables.$edit-zoom;
  zIndexBoard: z-index.$board;
  zIndexLinks: z-index.$links;
  baselineFontPx: board.$baseline-font-size;
  baselineWidth: board.$baseline-width;
  verticalBoardFontSize: variables.$vertical-board-font-size;
}
